export enum TvRoutes {
  STATS = "stats",
}
